// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartitionSpecInput } from './PartitionSpecInput';
import {
  PartitionSpecInputFromJSON,
  PartitionSpecInputFromJSONTyped,
  PartitionSpecInputToJSON,
  PartitionSpecInputToJSONTyped,
} from './PartitionSpecInput';

/**
 *
 * @export
 * @interface UpdatePartitionSpec
 */
export interface UpdatePartitionSpec {
  /**
   *
   * @type {PartitionSpecInput}
   * @memberof UpdatePartitionSpec
   */
  spec?: PartitionSpecInput;
}

/**
 * Check if a given object implements the UpdatePartitionSpec interface.
 */
export function instanceOfUpdatePartitionSpec(
  value: object,
): value is UpdatePartitionSpec {
  return true;
}

export function UpdatePartitionSpecFromJSON(json: any): UpdatePartitionSpec {
  return UpdatePartitionSpecFromJSONTyped(json, false);
}

export function UpdatePartitionSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdatePartitionSpec {
  if (json == null) {
    return json;
  }
  return {
    spec:
      json['spec'] == null
        ? undefined
        : PartitionSpecInputFromJSON(json['spec']),
  };
}

export function UpdatePartitionSpecToJSON(json: any): UpdatePartitionSpec {
  return UpdatePartitionSpecToJSONTyped(json, false);
}

export function UpdatePartitionSpecToJSONTyped(
  value?: UpdatePartitionSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    spec: PartitionSpecInputToJSON(value['spec']),
  };
}
